// react
import React from "react";

import Button from "../../../../components/Button";
// components
import Modal from "../../../../components/Modal";

// hooks
import useRequest from "../../../../hooks/useRequest";

// dependencies
import PropTypes from "../../../../lib/prop-types";

// styles
import css from "./RemoveConfirmationModal.module.scss";

const RemoveConfirmationModal = (props) => {
	const { handleClose, integrationToDelete } = props;

	const { revalidate: deleteSftpIntegration } = useRequest("deleteSftpIntegration", {}, { manual: true });

	const content = <div className={css.label}>{`Are you sure you want to remove ${integrationToDelete.name}?`} </div>;

	const handleDelete = async () => {
		await deleteSftpIntegration({
			filters: { integrationID: integrationToDelete._id },
		});
		handleClose();
	};

	const buttons = (
		<>
			<Button color="red" size="large" style={{ marginRight: 8 }} onClick={handleClose}>
				Cancel
			</Button>
			<Button color="green" size="large" onClick={handleDelete}>
				Confirm
			</Button>
		</>
	);

	return <Modal content={content} handleClose={handleClose} buttons={buttons} />;
};

RemoveConfirmationModal.propTypes = {
	handleClose: PropTypes.func.isRequired,
	integrationToDelete: PropTypes.object.isRequired,
};

export default RemoveConfirmationModal;
